define('GiftCertificateVariableAmount.HidePrice.View', [
    'Backbone',
    'jQuery',
    'giftcertificatevariableamount_hide_price_view.tpl'
], function (
    Backbone,
    jQuery,
    giftcertificatevariableamountHidePriceViewTpl
) {
    'use strict';

    return Backbone.View.extend({
        template: giftcertificatevariableamountHidePriceViewTpl,
        contextDataRequest: ['item'],
        initialize: function initialize(options) {
            var self = this;
            this.plp = options.plp;
        },
        getContext: function getContext() {
            var self = this;
            self.plp.on('afterShowContent', function afterShowContent() {
                if (self.contextData.item().custitem_is_variable_amount === true) {
                    jQuery('[data-item-id="' + self.contextData.item().internalid + '"] [data-view="ProductViewsPrice.Price"]').remove();
                }
            });
        }
    });
})
